import ChangeEmailComponent from './change-email.component';
import * as changeEmailActions from './change-email.actions';
import { changeEmailReducer } from './change-email.reducer';

export {
  ChangeEmailComponent,
  changeEmailActions,
  changeEmailReducer,
}



// WEBPACK FOOTER //
// src/acct/email/index.js